module.exports = __webpack_public_path__ + "static/media/vishwajit_kadam.35b02f4d.jpg";